import React from "react";
import { X, Home, CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePaymentCore } from "@/features/payment";
import { usePricingStore } from "@/features/pricing/store/pricing-store";
import { useTranslation } from "react-i18next";

export const PaymentCancelPage: React.FC = () => {
  const { completePayment } = usePaymentCore();
  const { openPricingModalWithTopup } = usePricingStore();
  const { t } = useTranslation();

  const handleGoHome = () => {
    completePayment();
  };

  const handleTryAgain = () => {
    completePayment();
    // Kısa bir gecikme ile pricing modal'ı aç
    setTimeout(() => {
      openPricingModalWithTopup();
    }, 100);
  };

  return (
    <div className="w-full px-4 py-8 md:px-8 md:py-10">
      <div className="mx-auto flex w-full max-w-xl flex-col items-center text-center">
        <div className="mb-6">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/20">
            <X className="h-8 w-8 text-amber-600 dark:text-amber-400" />
          </div>
        </div>

        <h2 className="mb-3 text-2xl font-semibold text-text-primary dark:text-text-primary md:text-3xl">
          {t("payment.cancel.title")}
        </h2>

        <p className="mb-8 max-w-lg text-sm leading-6 text-text-tertiary dark:text-text-tertiary md:text-base">
          {t("payment.cancel.description")}
        </p>

        <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
          <Button onClick={handleGoHome} className="w-full">
            <Home className="h-4 w-4" />
            {t("payment.cancel.goHome")}
          </Button>

          <Button
            variant="outline"
            onClick={handleTryAgain}
            className="w-full border-border-secondary-figma bg-transparent text-text-secondary hover:bg-bg-secondary-figma dark:border-border-secondary-figma dark:text-text-secondary dark:hover:bg-bg-secondary-figma"
          >
            <CreditCard className="h-4 w-4" />
            {t("payment.cancel.tryAgain")}
          </Button>
        </div>

        <div className="mt-6 w-full rounded-xl border border-amber-300/70 bg-amber-50/80 px-4 py-3 dark:border-amber-700/70 dark:bg-amber-900/20">
          <p className="text-sm font-medium text-amber-700 dark:text-amber-300">
            💡 {t("payment.cancel.tip")}
          </p>
        </div>
      </div>
    </div>
  );
};
